import { IUser } from '@geekbears/gb-ngrx-stack-base';
import { ProfilePicture } from '@modules/regular-user/profile/domain';
import { Company } from '@modules/super-admin/company/domain';

export interface GetUserDetailsResponse {
  data: AppUser;
}

export interface GetAllUsersResponse {
  data: AppUser[];
}

export interface SignupResponse {
  data: {
    authToken: string;
    refreshToken: string;
    user: AppUser;
  };
}

export interface StorageUser {
  email: string;
  firstName: string;
  lastName: string;
  roles: string[];
  _companyId: string;
  permissions: string[];
  requiresPasswordChange?: boolean;
  accountConfirmedAt?: Date | undefined;
  id: string;
  isSubscriptionBypassed?: boolean;
}

export abstract class AppUser implements IUser {
  abstract id: string;
  abstract email: string;
  abstract firstName: string;
  abstract lastName: string;
  abstract roles: string[];
  abstract permissions: string[] | undefined;
  abstract accountConfirmedAt?: Date | undefined;
  abstract blocked: boolean;
  abstract _companyId: string | null;
  abstract company: Company | null;
  abstract requiresPasswordChange: boolean;
  abstract department?: string;
  abstract companyName?: string;
  abstract profilePicture?: ProfilePicture;
  abstract _profilePicture?: string;
  abstract jobTitle?: string;
  abstract hasActiveSubscription: boolean;
  abstract isSubscriptionBypassed?: boolean;
  abstract otpVerified?: boolean;
  abstract profileComplete?: boolean;

  abstract get isSuperAdmin(): boolean;
  abstract get isManager(): boolean;
}
export interface CreateCompanyManager {
  firstName: string;
  lastName: string;
  jobTitle: string;
  department: string;
  companyName: string;
  email: string;
  password: string;
  confirmPassword: string;
}

export interface updateUser {
  email: string;
  firstName: string;
  lastName: string;
  jobTitle: string;
  department: string;
  role: string[];
}
